/**
 * @generated SignedSource<<cee061bb4a879ab1d97615059dec1c4e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ValidateCronExpressionInput = {
  cronExpression: string;
};
export type ValidateCronExpressionMutation$variables = {
  input: ValidateCronExpressionInput;
};
export type ValidateCronExpressionMutation$data = {
  readonly validateCronExpression: {
    readonly errorMessage: string | null | undefined;
    readonly isValid: boolean;
    readonly nextFireTime: any | null | undefined;
  };
};
export type ValidateCronExpressionMutation = {
  response: ValidateCronExpressionMutation$data;
  variables: ValidateCronExpressionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ValidateCronExpressionPayload",
    "kind": "LinkedField",
    "name": "validateCronExpression",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isValid",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "nextFireTime",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "errorMessage",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ValidateCronExpressionMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ValidateCronExpressionMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "8309e53aed7836b60f1b47e88afb370a",
    "id": null,
    "metadata": {},
    "name": "ValidateCronExpressionMutation",
    "operationKind": "mutation",
    "text": "mutation ValidateCronExpressionMutation(\n  $input: ValidateCronExpressionInput!\n) {\n  validateCronExpression(input: $input) {\n    isValid\n    nextFireTime\n    errorMessage\n  }\n}\n"
  }
};
})();

(node as any).hash = "b95a1a9001efaaeadc08c62c951737af";

export default node;
